module.exports = __webpack_public_path__ + "static/media/68.9fd6cb69.gif";